import PlansList from './PlansList';

export default PlansList;
